module.exports = __webpack_public_path__ + "media/paliwa/hybrid@2x-46a0cb4a.png";